module.exports = __webpack_public_path__ + "img/3.f6a1ec08.gif";